// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","453":"54292a4b","667":"a420e5d3","890":"d626ea06","921":"56f7da9a"}[chunkId] + ".chunk.js";
};